import { jsx as _jsx } from "react/jsx-runtime";

function SvgPolicy() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.777 3c0-1.471 1.127-3 3-3h10.171a3 3 0 012.122.879l3.828 3.828a3 3 0 01.879 2.121V21c0 .827-.271 1.6-.844 2.166-.571.566-1.348.834-2.183.834H4.777c-.836 0-1.61-.269-2.177-.84-.565-.571-.823-1.343-.823-2.16V3zm3-1c-.613 0-1 .471-1 1v18c0 .398.12.626.244.752.123.124.349.248.756.248H18.75c.408 0 .644-.125.776-.255.13-.13.25-.357.25-.745V8h-4a2 2 0 01-2-2V2h-9zm11 .414L19.363 6h-3.586V2.414zM10.77 18v-2.412h1.094c.866 0 1.546-.207 2.04-.62.499-.417.748-.972.748-1.665 0-.469-.116-.887-.347-1.255a2.224 2.224 0 00-.971-.855c-.417-.201-.897-.302-1.441-.302H9.057V18h1.714zm1.123-3.735h-1.123v-2.051h1.143c.309.003.553.104.732.303.179.198.269.463.269.796 0 .302-.088.537-.264.703-.173.166-.425.249-.757.249z"
    }, void 0)
  }), void 0);
}

export default SvgPolicy;